import script from "./IC.vue?vue&type=script&setup=true&lang=js"
export * from "./IC.vue?vue&type=script&setup=true&lang=js"

import "./IC.vue?vue&type=style&index=0&id=32e8db33&scoped=true&lang=css"

import exportComponent from "/Users/louis/Dev/source/images/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32e8db33"]])

export default __exports__